import { render, staticRenderFns } from "./EditSSN.vue?vue&type=template&id=1caa4b8e&scoped=true&"
import script from "./EditSSN.vue?vue&type=script&lang=js&"
export * from "./EditSSN.vue?vue&type=script&lang=js&"
import style0 from "./EditSSN.vue?vue&type=style&index=0&id=1caa4b8e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1caa4b8e",
  null
  
)

export default component.exports